import request from '@/utils/request'

/**
 * 获取字典列表
 * @param {Object} params 查询参数
 * @returns {Promise} 返回字典列表数据
 */
export function listDict(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/dict.listDict',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取字典类型列表
 * @param {Object} params 查询参数
 * @returns {Promise} 返回字典类型列表数据
 */
export function listDictSpec(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/dictSpec.listDictSpec',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 添加字典
 * @param {Object} data 字典数据
 * @returns {Promise} 返回操作结果
 */
export function saveDict(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/dict.saveDict',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 修改字典
 * @param {Object} data 字典数据
 * @returns {Promise} 返回操作结果
 */
export function updateDict(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/dict.updateDict',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除字典
 * @param {Object} data 字典数据
 * @returns {Promise} 返回操作结果
 */
export function deleteDict(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/dict.deleteDict',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}